import { useEffect, useRef, useState } from "react";
import {
  Accordion,
  Group,
  NumberInput,
  Paper,
  RangeSlider,
} from "@mantine/core";
import { useDebouncedValue, useMediaQuery } from "@mantine/hooks";
import { BiCoinStack } from "react-icons/bi";
import { encodeDelimitedArray, useQueryParam } from "use-query-params";
import AccordionFilterLabel from "../filter-components/AccordionFilterLabel";

const CustomArrayParam = {
  encode: (array) => encodeDelimitedArray(array, "|"),
  decode: (arrayStr) => arrayStr?.split("|").map((price) => parseInt(price)),
};

const PriceFilter = () => {
  const isMobile = useMediaQuery("(max-width: 992px)");
  const [price, setPrice] = useQueryParam("price", CustomArrayParam);
  const [value, setValue] = useState(price ?? [0, 15000]);
  const [isChangeTriggered, setChangeTriggered] = useState(false);
  const [debounced] = useDebouncedValue(value, 400);
  const handlers = useRef();

  useEffect(() => {
    if (isChangeTriggered) {
      setPrice(debounced);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounced]);

  const handleRangeSliderChange = (value) => {
    setChangeTriggered(true);
    setValue(value);
  }

  const handleMinPriceChange = (price) => {
    if (price) {
      setChangeTriggered(true);
      setValue([price, value[1]]);
    }
  }

  const handleMaxPriceChange = (price) => {
    if (price) {
      setChangeTriggered(true);
      setValue([value[0], price]);
    }
  }

  return (
    <Paper
      shadow={!isMobile ? "sm" : ""}
      p={isMobile ? 0 : "xs"}
      mb={!isMobile ? 15 : ""}
      withBorder
    >
      <Accordion
        defaultValue="Prijs"
        variant="filled"
        styles={{ panel: { background: "white" } }}
      >
        <Accordion.Item value="Prijs">
          <Accordion.Control>
            <AccordionFilterLabel
              label={"Prijs"}
              icon={BiCoinStack}
              color={"blue"}
            />
          </Accordion.Control>
          <Accordion.Panel>
            <RangeSlider
              value={value}
              defaultValue={[0, 15000]}
              max={15000}
              label={(value) => `€ ${value},-`}
              onChange={handleRangeSliderChange}
            />
            <Group position="apart" mt={15}>
              <NumberInput
                hideControls
                description="Min."
                value={value[0]}
                size="md"
                onChange={handleMinPriceChange}
                handlersRef={handlers}
                max={value[1]}
                min={0}
                step={1}
                icon={<span>€</span>}
                styles={{ root: { width: "45%" } }}
              />
              <NumberInput
                hideControls
                description="Max."
                value={value[1]}
                size="md"
                onChange={handleMaxPriceChange}
                handlersRef={handlers}
                max={15000}
                min={10}
                step={1}
                icon={<span>€</span>}
                styles={{ root: { width: "45%" } }}
              />
            </Group>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Paper>
  );
};

export default PriceFilter;
